import React, { useState, useEffect, useRef } from 'react';

const OnboardingSection: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const touchStartX = useRef<number>(0);
  const touchEndX = useRef<number>(0);
  const isDragging = useRef(false);

  const handleDragStart = (e: React.MouseEvent | React.TouchEvent) => {
    isDragging.current = true;
    if ('touches' in e) {
      touchStartX.current = e.touches[0].clientX;
    } else {
      touchStartX.current = e.clientX;
    }
  };

  const handleDragMove = (e: React.MouseEvent | React.TouchEvent) => {
    if (!isDragging.current) return;
    
    if ('touches' in e) {
      touchEndX.current = e.touches[0].clientX;
    } else {
      touchEndX.current = e.clientX;
    }
  };

  const handleDragEnd = () => {
    if (!isDragging.current) return;
    
    const diff = touchStartX.current - touchEndX.current;
    const threshold = 50; // 스와이프 감지 임계값

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        // 왼쪽으로 스와이프
        handleNext();
      } else {
        // 오른쪽으로 스와이프
        handlePrev();
      }
    }
    
    isDragging.current = false;
  };

  const slides = [
    '/images/feature-onboarding1.png',
    '/images/feature-onboarding2.png',
    '/images/feature-onboarding3.png'
  ];

  // 자동 넘김 제거

  const handleNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="pt-8 pb-16 px-4 bg-white">
      <div className="max-w-[480px] mx-auto">
        <h2 className="text-2xl font-bold text-orange-500 mb-8 px-4">
          떠리 서비스 소개
        </h2>
        <div className="relative">
          {/* Carousel Container */}
          <div className="overflow-hidden rounded-3xl">
            <div 
              className="flex transition-transform duration-500 ease-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              onTouchStart={handleDragStart}
              onTouchMove={handleDragMove}
              onTouchEnd={handleDragEnd}
              onMouseDown={handleDragStart}
              onMouseMove={handleDragMove}
              onMouseUp={handleDragEnd}
              onMouseLeave={handleDragEnd}
            >
              {slides.map((slide, index) => (
                <div 
                  key={index}
                  className="w-full flex-shrink-0"
                >
                  <img 
                    src={slide} 
                    alt={`온보딩 이미지 ${index + 1}`}
                    className="w-full h-auto object-cover"
                    style={{ aspectRatio: '4/5' }}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Button */}
          <button 
            onClick={handleNext}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/10 shadow-lg rounded-full p-3 hover:bg-white/70 transition-all transform hover:scale-110 active:scale-95"
            aria-label="다음 슬라이드"
          >
            <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Dots Indicator */}
        <div className="flex justify-center gap-3 mt-8">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`h-3 rounded-full transition-all ${
                currentSlide === index 
                  ? 'bg-orange-500 w-12' 
                  : 'bg-gray-300 hover:bg-gray-400 w-3'
              }`}
              aria-label={`슬라이드 ${index + 1}로 이동`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OnboardingSection;